module.exports = __webpack_public_path__ + "assets/img/s2_chart-1.7e42bec6.png";